module.exports = __webpack_public_path__ + "static/toolkit-phones-7c027e2ef377c04214fa8323136d80f0.png";